import React from 'react';
import { faStar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface StarRegularIconProps {
  className?: string;
}

export default function StarRegularIcon(props: StarRegularIconProps) {
  return <FontAwesomeIcon icon={faStar} {...props} />;
}
